import React from "react";

type WithFilteredPropsInput = {
    children: React.ReactNode;
    context: { state: { settings: { userSettings: unknown } } };
    data: unknown;
    id: string;
    locale: LocaleSettings;
};

type FilteredProps = {
    children: React.ReactNode;
    data: unknown;
    id: string;
    locale: LocaleSettings;
    userSettings: unknown;
};

export const withFilteredProps =
    <P extends FilteredProps>(Component: React.ComponentType<P>) =>
    (props: WithFilteredPropsInput) => {
        const { children, context, data, id, locale } = props;

        const { state } = context;
        const { settings } = state;
        const { userSettings } = settings;

        const filteredProps = {
            children,
            data,
            id,
            locale,
            userSettings,
        } as P;

        return <Component {...filteredProps} />;
    };
